import { breakpoints } from 'helpers/utils'
import styled from 'styled-components'
import Calendar from './Calendar'

const { mobile } = breakpoints
const cellWidth = 30

export const StyledIntervalForm = styled.div`
position: absolute;
padding: 20px;
width: 411px;
height: 439px;
border-radius: 5px;
box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
border: 1px solid #CDCDCD;
z-index: 5;
right: 0;
top: 45px;
background-color: white;
@media (max-width: 768px){
	width: 300px;
	height: 339px;
	padding: 10px;
}
& .form_badge__container {
	display: flex;
	flex-direction: column;
	&:nth-child(2) {
	margin-top: 42px;
	}
	&__period {
		font-size: 14px;
		font-weight: 500;
		color: #589ffb;
	}
	&__label {
		font-size: 14px;
		font-weight: 400;
		color: #3e4c57;
		margin-bottom: 10px;
	}
	&__year_list {
		display: grid;
		height: 30px;
		grid-template-columns: repeat(auto-fill, 63px);
		grid-column-gap: 10px;
		font-size: 16px;
		font-weight: 400;
		
	}
	&__month_list {
		display: grid;
		grid-template-columns: repeat(auto-fill, 116px);
		gap: 10px;
		margin-bottom: 40px;
	}
	.form_badge {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: white;
		border-radius: 5px;
		border: 1px solid #CDCDCD;
		font-size: 16px;
		font-weight: 400;
		color: #3e4c57;
		padding: 8px 0;
		&.disabled {
			pointer-events: none;
			color: #cbcbcb;
		}
		&:hover {
			cursor: pointer;
		}
		&.active {
			color: #4A90E2;
			box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
		}
	}

	@media (max-width: 768px){
		&__year_list {
			display: grid;
			height: 7px;
			grid-template-columns: repeat(auto-fill, 62px);
			grid-column-gap: 10px;
			& .form_badge{
				font-size: 13px;
			}
		}
		&__month_list {
			grid-template-columns: repeat(auto-fill, 85px);
			gap: 10px;
			margin-bottom: 10px;
			& .form_badge{
				font-size: 13px;
			}
		}
	}
}
& .form_calendar__list {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	& .calendar__controls > div {
		border-radius: 100%;
		background-color: #ffffff;
	}
	& > div {
		width: 340px;
	}
}
& .form__actions {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
	&__btn {
		width: 180px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		background-color: #ffffff;
		font-size: 16px;
		font-weight: 500;
		@media (max-width: 768px){
			width: 129px;
			height: 30px;
			font-size: 13px;
		}
		&:first-of-type {
			margin-right: 20px;
		}
		&:hover {
			cursor: pointer;
		}
		&:active{
			box-shadow: inset 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
		}
	}
	&__cancel {
		color: #434343;
		background-color: #E6E6E6;
		border: 1px solid #CDCDCD;
		&:hover{
			background-color: #CDCDCD;
			border: 1px solid #E6E6E6;
		}
	}
	&__confirm {
		color: #ffffff;
		background-color: #4A90E2;
		border: 1px solid #4382CB;
		&:hover{
			background-color: #4382CB;
			border: 1px solid #4A90E2;
		}
		&.disabled {
			pointer-events: none;
			color: #4A90E2;
			background-color: #4382CB;
		}
	}
}
`

export const StyledCalendarRow = styled.div`
display: grid;
justify-content: space-between;
grid-template-columns: repeat(7, ${cellWidth}px);
font-size: 14px;
font-weight: 400;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: center;
@media (max-width: 768px) {
	grid-template-columns: repeat(7, 60px);
	font-size: 18px;
	font-weight: 500;
}
@media (max-width: 473px) {
	grid-template-columns: repeat(7, 47.5px);
	font-size: 16px;
}
@media (max-width: 768px) and  (max-height: 610px){
	grid-template-columns: repeat(7, 47.5px);
	font-size: 16px;
}
@media (max-width: 374px) {
	grid-template-columns: repeat(7, ${cellWidth}px);
	font-size: 14px;
	font-weight: 400;
}
`

export const StyledCalendarCell = styled.div`
text-align: center;
display: flex;
justify-content: center;
align-items: center;
width: ${cellWidth}px;
height: ${cellWidth}px;
&:hover{
	background-color: #FAFAFA;
}
@media (max-width: 768px) {
	width: 60px;
	height: 60px;
}
@media (max-width: 473px) {
	width: 47.5px;
	height: 47.5px;
}
@media (max-width: 768px) and  (max-height: 610px){
	width: 47.5px;
	height: 47.5px;
}
@media (max-width: 374px) {
	width: ${cellWidth}px;
	height: ${cellWidth}px;
}
background-color: ${props => props.isActive ? '#D4E8FF' : 'none'};
&:hover {
	cursor: pointer;
}
& span {
	color: ${({ textColor }) => textColor && textColor};
}
`

export const StyledWeekdays = styled.div`
display: flex;
justify-content: space-between;
margin-top: 16px;
& div {
	width: ${cellWidth}px;
	height: ${cellWidth}px;
	@media (max-width: 768px) {
		width: 60px;
		height: 60px;
	}
	@media (max-width: 473px) {
		width: 47.5px;
		height: 47.5px;
	}
	@media (max-width: 768px) and  (max-height: 610px){
		width: 47.5px;
		height: 47.5px;
	}
	@media (max-width: 374px) {
		width: ${cellWidth}px;
		height: ${cellWidth}px;
	}
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
}
`

export const StyledWeekday = styled.span`
	font-size: 14px;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.21;
	letter-spacing: normal;
	text-align: center;
	color: ${props => (props.day > 5) ? '#F2874F' : '#565656'};
	@media (max-width: 768px) {
		font-size: 18px;
	}
	@media (max-width: 473px) {
		font-size: 16px;
	}
	@media (max-width: 768px) and  (max-height: 610px){
		font-size: 16px;
	}
	@media (max-width: 374px) {
		font-size: 14px;
	}
`

export const StyledPickerWrapper = styled.div`
	&>span{
		display: block;
		font-size: 14px;
		font-weight: 400;
		margin-bottom: 10px;
	}
`

export const StyledPicker = styled.div`
display: flex;
justify-content: ${({ pickerStyle }) => pickerStyle === 'dateInterval' ? 'flex-end' : 'space-between'};
align-items: center;
min-width:  ${({ pickerStyle }) => pickerStyle === 'dateInterval' ? '50px' : '178px'};
height: ${({ pickerCssStyles: { height } }) => height || '40px'};
border-radius: 5px;
border: 1px solid #CDCDCD;
padding-left: ${({ pickerCssStyles: { padding_left } }) => padding_left || '20px'};
padding-right: ${({ pickerCssStyles: { padding_right } }) => padding_right || '15px'};
font-size: ${({ pickerCssStyles: { font_size } }) => font_size || 'black'};
color: #434343;
font-weight: ${({ pickerCssStyles: { font_weight } }) => font_weight || '600'};
float: ${({ pickerStyle }) => pickerStyle === 'dateInterval' ? 'right' : 'none'};
background-color: white;
width: fit-content;
transition: box-shadow .5s;
box-shadow: ${({ calendarVisible }) => calendarVisible ? '0px 0px 7px 0px rgba(0, 0, 0, 0.15)' : 'none'};
&:hover{
	-webkit-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
	-moz-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
	box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
}
& svg {
	display: none;
}
& .calendar_icon_first svg{
	display: block;
}
& .calendar_icon svg{
	display: block;
	transform: ${({ pickerStyle, calendarVisible }) => ((pickerStyle === 'branch' && calendarVisible) || (pickerStyle === 'dateCalendar' && calendarVisible)) ? 'rotate(180deg)' : 'none'};
	transition: transform .5s;
}
&:hover {
	cursor: pointer;
}
& .arrow {
	margin-left: 10px;
}
& span:first-child {
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	display: flex;
	align-items: center;
	& .formated_date {
		font-style: normal !important;
		color: ${({ pickerCssStyles: { color } }) => color || 'black'};
		font-size: 16px;
		font-weight: 600;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}
@media (max-width: 1200px) {
	width: fit-content;
}
@media (max-width: 768px) {
	min-width: 70px;
	margin-left: 10%;
	width: fit-content;
	float: right;
}
@media (max-width: 576px) {
	& span:first-child .formated_date{
		font-size: 14px;
	}
	& .calendar_icon svg, .calendar_icon_first svg{
		width: 30px;
	}
}
@media (max-width: 475px) {
	height: 35px;
	& span:first-child .formated_date{
		font-size: 13px;
	}
}
@media (max-width: 454px) {
	& span:first-child .formated_date{
		font-size: 12px;
	}
}
@media (max-width: 432px) {
	& span:first-child .formated_date{
		font-size: 11px;
	}
}
@media (max-width: 412px) {
	height: 32px;
	& span:first-child .formated_date{
		font-size: 10.5px;
	}
}
@media (max-width: 400px) {
	margin-left: 1.5%;
	height: 35px;
	& span:first-child .formated_date{
		font-size: 13px;
	}
	& .calendar_icon svg, .calendar_icon_first svg{
		width: 25px;
	}
}
@media (max-width: 390px) {
	& span:first-child .formated_date{
		font-size: 12px;
	}
}
@media (max-width: 383px) {
	height: 32px;
	& span:first-child .formated_date{
		font-size: 11px;
	}
}
@media (max-width: 372px) {
	& span:first-child .formated_date{
		font-size: 10px;
	}
}
@media (max-width: 358px) {
	& .calendar_icon svg, .calendar_icon_first svg{
		width: 22px;
	}
}
@media (max-width: 353px) {
	height: 31px;
	& span:first-child .formated_date{
		font-size: 9px;
	}
}

&.similar_header_pages{
	border: none;
	box-shadow: none;
	margin-bottom: 25px;
	&:hover{
		box-shadow: none;
	}
	& .calendar_icon .arrow_down_mini{
		margin-left: 11px;
	}	

	& span:first-child {
		& .formated_date {
			max-width: unset;
		}
	}
}

&.top_combinations_dateInterval{
	border: 1px solid #CDCDCD;
	&:hover{
		-webkit-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
		-moz-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
		box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
	}
}
`

export const StyledCalendar = styled(Calendar)`
position: absolute;
width: 262px;
top: 100%;
margin-top: 10px;
z-index: 5;
border-radius: 5px;
box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
border: 1px solid #CDCDCD;
background-color: #ffffff;
padding: 20px;
@media (max-width: 1200px) {
	left: none;
}
@media (${mobile}) {
	top: 140px;
	@media (max-width: 768px) {
		left: 50%;
  		top: 50%;
		transform: translate(-50%, -50%);
		width: 472px;
		z-index: 12;
	}
	@media (max-width: 473px) {
		left: 50%;
  		top: 50%;
		transform: translate(-50%, -50%);
		width: 374px;
	}
	@media (max-width: 768px) and  (max-height: 610px){
		left: 50%;
  		top: 50%;
		transform: translate(-50%, -50%);
		width: 374px;
		z-index: 20;
	}
	@media (max-width: 374px) {
		width: 262px;
	}
}
`

export const StyledCalendarHeader = styled.div`
display: flex;
justify-content: space-between;
& .calendar__title {
	font-size: 18px;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #4A90E2;
	@media (${mobile}) {
		@media (max-width: 768px) {
			font-size: 28px;
		}
		@media (max-width: 473px) {
			font-size: 25px;
		}
		@media (max-width: 768px) and  (max-height: 610px){
			font-size: 25px;
		}
		@media (max-width: 374px) {
			font-size: 18px;
		}
	}
}
& .calendar__controls {
	display: flex;
	align-items: center;
	& .control {
		width: 22px;
		height: 22px;
		border-radius: 100%;
		border: 1px solid #CDCDCD;
		display: flex;
		justify-content: center;
		align-items: center;
		@media (max-width: 768px) {
			width: 34px;
			height: 34px;
		}
		@media (max-width: 374px) {
			width: 22px;
			height: 22px;
		}
		&:hover {
			cursor: pointer;
			box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
			& path:nth-child(2){
				fill: #434343;
			}
		}
		&:active{
			& path:nth-child(2){
				fill: #4A90E2;
			}
		}
	}
	& .arrow {
		border: solid black;
		border-width: 0 1px 1px 0;
		display: inline-block;
		padding: 2px;
		&.left {
			transform: rotate(135deg);
			-webkit-transform: rotate(135deg);
		}
		&.right {
			transform: rotate(-45deg);
			-webkit-transform: rotate(-45deg);
		}
	}
	&__back {
		transform: rotate(180deg);
	}
	&__next {
		margin-left: 8px;
	}
}
`
